import React, { useEffect, useState } from 'react'
import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material'
import SelectFiled from '../../common/textfield/SelectFiled'
import Fields from '../Dashboard/Fields';
import { ExpandMore } from '@mui/icons-material';
import { isAnswered, evaluateCondition } from '../../../utils/questionnaireSupport';
import TextEditor from '../../common/textfield/TextEditor';
import TextInput from '../../common/textfield/TextInput';


const QuestionnaireRenderer = ({
  formik,
  questionResponse,
  questionnaire,
  parentIndex,
  readOnly = false
}) => {
  const [visibleQuestions, setVisibleQuestions] = useState([]);

  useEffect(() => {
    const visibility = questionResponse.map((respItem, idx) => {
      const questionnaireItem = questionnaire?.item?.find(q => q.id === respItem.questionId);
      return questionnaireItem?.enableWhen
        ? evaluateCondition(questionnaireItem.enableWhen.expression, questionResponse)
        : true;
    });
    
    // Clear answers for hidden questions
    visibility.forEach((isVisible, idx) => {
      if (!isVisible && questionResponse[idx]) {
        const currentItem = questionResponse[idx];
        
        // Only clear if answer exists and is not already empty
        if (currentItem.answer && currentItem.answer.length > 0) {
          const needsReset = currentItem.answer.some(ans => 
            (ans.answer !== "" && ans.answer !== null && ans.answer !== undefined) || 
            ans.valueBoolean === true
          );
          
          if (needsReset) {
            // Create empty answers based on question type
            let emptyAnswers;
            
            switch (currentItem.questionType) {
              case "radio":
              case "checkbox":
                // For radio/checkbox, set all valueBoolean to false
                emptyAnswers = currentItem.answer.map(ans => ({
                  ...ans,
                  answer: "",
                  valueBoolean: false
                }));
                break;
                
              case "dropDown":
              case "freeText":
              case "singleFreeText":
              default:
                // For text fields and dropdowns, clear the answer string
                emptyAnswers = currentItem.answer.map(ans => ({
                  ...ans,
                  answer: ""
                }));
                break;
            }
            
            // Update formik with cleared answers
            formik.setFieldValue(`questionResponse[${idx}].answer`, emptyAnswers);
          }
        }
      }
    });
    
    setVisibleQuestions(visibility);
  }, [questionResponse, questionnaire]);

  return questionResponse?.map((item, index) => {
    const isEnabled = visibleQuestions[index];
    if (!isEnabled) {
      return null; // Do not render if the condition is false
    }

    return (
      <Accordion 
        key={index}
        defaultExpanded={true}
      >
        <AccordionSummary expandIcon={<ExpandMore />}>
          <Typography>
            {item?.question}
            {item?.required ? <span style={{ color: "red" }}> *</span> : null}
            {item?.required ? formik.errors.isQuestionsError && !isAnswered(item) && (
              <div className="error-message" style={{ color: "red", fontSize: "12px" }}>
                Mandatory Question
              </div>
            ) : null}
          </Typography>
        </AccordionSummary>

        {/* freeText question type */}
        {item.questionType === "freeText" && (
          <AccordionDetails sx={{ padding: 0 }}>
            <TextEditor
              key={`text-editor-${parentIndex}-${index}`}
              keyField={`questionResponse[${index}].answer[0].answer`}
              formik={formik}
              defaultValue={item?.answer?.[0]?.answer || ""}
              label={false}
              readOnly={readOnly}
            />
          </AccordionDetails>
        )}

        {/* singleFreeText question type */}
        {item.questionType === "singleFreeText" && (
          <AccordionDetails sx={{ padding: 0 }}>
            <TextInput
              key={`text-input-${parentIndex}-${index}`}
              keyField={`questionResponse[${index}].answer[0].answer`}
              formik={formik}
              defaultValue={item?.answer?.[0]?.answer || ""}
              label={false}
              readOnly={readOnly}
              placeholder="Start writing..."
            />
          </AccordionDetails>
        )}

        {/* radio or checkbox question types */}
        {(item.questionType === "radio" || item.questionType === "checkbox") && (
          <AccordionDetails sx={{ padding: 0 }}>
            <Fields
              question={item}
              formik={formik}
              Questions={questionResponse}
              propIndex={index}
              hideMandatory={true}
              readOnly={readOnly}
            />
          </AccordionDetails>
        )}

        {/* dropDown question type */}
        {item.questionType === "dropDown" && (
          <AccordionDetails sx={{ padding: 0 }}>
            <SelectFiled
              key={`dropdown-editor-${parentIndex}-${index}`}
              keyField={`questionResponse[${index}].answer[0].answer`}
              style={{ fontSize: 16 }}
              formik={formik}
              options={item.answerOption}
              readOnly={readOnly}
              selectDisabledValue={true}
            />
          </AccordionDetails>
        )}
      </Accordion>
    )
  })
}

export default QuestionnaireRenderer;